module.exports = __webpack_public_path__ + "static/img/产品中心-问煤-case.15694231.png";